import { Box, Collapse, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { Button } from '@mui/material';
import { affilieService } from 'core/services';
import moment from 'moment';
import React, { useState } from 'react';
import { useHistory } from 'react-router';

// Define the interface for the props
type Props = {
    affilies: Array<Affiliate>;
};

type Affiliate = {
    codAffilie: string;
    numSecu: string;
    nom: string;
    prenom: string;
    contracts: Array<Contract>;
};

type Contract = {
    contractId: string;
    contractName: string;
};

const AffiliateList: React.FC<Props> = ({ affilies }) => {
    const history = useHistory();
    const [openRow, setOpenRow] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const [adhesions, setAdhesions] = useState([]);
    const [currentChoise, setCurrentChoise] = useState(null);

    const handleRowClick = async (codAffilie: string, numSecu: string) => {
        if (currentChoise && currentChoise === codAffilie) return;
        setLoading(true);
        setCurrentChoise(codAffilie);
        setOpenRow((prev) => (prev === codAffilie ? null : codAffilie));
        const result = await affilieService.getAffilie(numSecu);
        const filtredResult = result.filter((r) => r.type == 'P'); // TODO :: refactor
        setAdhesions(filtredResult);
        setLoading(false);
    };

    const handleAdhesionSelection = (codAffilie, codContrat) => {
        console.log(codAffilie, codContrat);
        history.push('/arrets/declare?codAffilie=' + codAffilie + '&codContrat=' + codContrat);
    };

    if (affilies.length === 0) {
        return null; // Return null if the list is empty
    }

    return (
        <Box style={{ minWidth: '800px' }}>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell style={{ fontWeight: 'bold' }}>Nom prénom</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Numéro de Sécu.</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {affilies.map((affiliate) => (
                            <React.Fragment key={affiliate.codAffilie}>
                                <TableRow hover onClick={() => handleRowClick(affiliate.codAffilie, affiliate.numSecu)}>
                                    <TableCell>
                                        <IconButton size="small">{openRow === affiliate.codAffilie ? <KeyboardArrowUp /> : <KeyboardArrowDown />}</IconButton>
                                    </TableCell>
                                    <TableCell>
                                        {affiliate.nom} {affiliate.prenom}
                                    </TableCell>
                                    <TableCell>{affiliate.numSecu}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={4}>
                                        <Collapse in={openRow === affiliate.codAffilie} timeout="auto" unmountOnExit>
                                            {loading ? (
                                                'Chargement... '
                                            ) : (
                                                <Box margin={0} style={{ background: '#efefef' }}>
                                                    {adhesions.length && (
                                                        <Table size="small" aria-label="contracts">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Contrat</TableCell>
                                                                    <TableCell>Souscripteur</TableCell>
                                                                    <TableCell>Categorie</TableCell>
                                                                    <TableCell>Matricule</TableCell>
                                                                    <TableCell>Début</TableCell>
                                                                    <TableCell>Fin</TableCell>
                                                                    <TableCell></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {adhesions &&
                                                                    adhesions.map((adhesion) => (
                                                                        <TableRow key={adhesion.cod + '-' + adhesion.codContrat}>
                                                                            <TableCell>{adhesion.lbContrat}</TableCell>
                                                                            <TableCell>{adhesion.nomSouscripteur}</TableCell>
                                                                            <TableCell>{adhesion.lbCollege}</TableCell>
                                                                            <TableCell>{adhesion.matriculeEntreprise}</TableCell>
                                                                            <TableCell>{adhesion.dtDebut ? moment(adhesion.dtDebut.date).format('DD-MM-YYYY') : null}</TableCell>
                                                                            <TableCell>{adhesion.dtFin ? moment(adhesion.dtFin.date).format('DD-MM-YYYY') : null}</TableCell>
                                                                            <TableCell>
                                                                                <Button onClick={() => handleAdhesionSelection(adhesion.cod, adhesion.codContrat)}>Choisir</Button>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                            </TableBody>
                                                        </Table>
                                                    )}
                                                </Box>
                                            )}
                                        </Collapse>
                                    </TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default AffiliateList;
